/**
 * Make first letter of the given string uppercase.
 */
const capitalize = (str: string) => {
  return str.slice(0, 1).toUpperCase() + str.slice(1);
};

export default capitalize;
